import {
    useCallback,
    useState,
    useMemo,
    type FC,
    useRef,
    useId
} from "react";
import type {
    View
} from "react-native";
import type IDropdownMenuSubProps from "./type";
import {
    useDropdownMenuLevelContext,
    DropdownMenuSubContext
} from "../../context";
import type {
    DropdownMenuSubContextType,
    DropdownMenuOpenModeType
} from "../../type";

const DropdownMenuSub: FC<IDropdownMenuSubProps> = ({
    children
}) => {
    const levelContext = useDropdownMenuLevelContext({
        part: "Sub"
    });

    const triggerId = useId();

    const subId = useId();

    const anchorRef = useRef<View | null>(null);

    const [
        openMode,
        setOpenMode
    ] = useState<DropdownMenuOpenModeType>("pointer");

    const handleSubOpenChange = levelContext?.handleSubOpenChange;

    const isOpen = levelContext?.openSubId === subId;

    const handleOpenChange = useCallback((nextIsOpen: boolean, nextOpenMode?: DropdownMenuOpenModeType) => {
        if(nextIsOpen) {
            setOpenMode(nextOpenMode ?? "pointer");
        }

        handleSubOpenChange?.(nextIsOpen ? subId : null);
    }, [
        handleSubOpenChange,
        subId
    ]);

    const value = useMemo<DropdownMenuSubContextType>(() => ({
        handleOpenChange,
        anchorRef,
        triggerId,
        openMode,
        isOpen,
        subId
    }), [
        handleOpenChange,
        triggerId,
        openMode,
        isOpen,
        subId
    ]);

    return <DropdownMenuSubContext.Provider
        value={value}
    >
        {children}
    </DropdownMenuSubContext.Provider>;
};
export default DropdownMenuSub;
